import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { BulkPostOrderRequest, BulkPostOrderResponseInfo } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { upsertOrderAdapter } from './adapters/upsertOrderAdapter';
import { DisplayIArrival } from '@/recommendOrderModule/pages/interfaces/displayIArrival';
import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
/**
 * 確定発注保存のビジネスロジック
 */
export class UpsertOrderUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注登録に使用するUseCase
   * DBの定義とIBusinessとの形式の差異をここで合わせて登録する
   * @param registerOrderInfo - 集計されていないビジネス
   * @param aggregateBusinessId - 集計ID
   * @param orderBasisInfo - 発注根拠情報
   */
  public async Execute(
    registerOrderInfo: DisplayIArrival[],
    aggregateBusinessId: string,
    orderBasisInfo: IOrderBasis
  ): Promise<INetworkResult<BulkPostOrderResponseInfo, IError>> {
    const request: BulkPostOrderRequest = upsertOrderAdapter.adapt(registerOrderInfo, aggregateBusinessId, orderBasisInfo);
    try {
      const result = await this.repository.bulkPost(request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          return {
            status: {
              type: 'error',
              error: result.status.error,
            },
          };
        default:
          throw Error();
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: -1,
            code: 'unknown',
            message: '想定外のエラー',
          },
        },
      };
    }
  }
}
